import { render, staticRenderFns } from "./requestVaccine.vue?vue&type=template&id=2e64d5e9&scoped=true&"
import script from "./requestVaccine.vue?vue&type=script&lang=js&"
export * from "./requestVaccine.vue?vue&type=script&lang=js&"
import style0 from "./requestVaccine.vue?vue&type=style&index=0&id=2e64d5e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e64d5e9",
  null
  
)

export default component.exports